import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import { env } from "@/config";
import { hasConsent, onConsentGranted } from "@/lib/consent";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

let sentryInitialized = false;

const initSentry = (): void => {
  if (sentryInitialized) return;
  const dsn = env.sentryDsn;
  if (!dsn) return;
  sentryInitialized = true;

  Sentry.init({
    dsn,
    environment: env.sentryEnvironment,
    enabled: false,
    // release: env.sentryRelease,
    sendDefaultPii: true,
    integrations: [
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
  });
};

const isProduction = env.isProd;
const hasCookiebotScript = Boolean(document.getElementById("Cookiebot"));

if (!isProduction || !hasCookiebotScript) {
  initSentry();
} else if (hasConsent("statistics")) {
  initSentry();
} else {
  onConsentGranted("statistics", initSentry);
}
